import React from "react";

import { useParams } from "react-router-dom";
import InactivityLogout from "../services/InactivityLogout";
import Header from "../components/Header";
import AdvancedSearchSection from "../components/AdvancedSearchSection";

export default function AdvancedSearch() {
  const { email } = useParams();

  return (
    <InactivityLogout>
      <Header searchterm={email} />
      <AdvancedSearchSection searchterm={email} />
    </InactivityLogout>
  );
}
